import React from "react";
import StudioHome from "./StudioHome";

function Home() {
  return <StudioHome />;
}

export default Home;
